/**
 * @desc H5StoreReviews
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.StoreReviews,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.HttpResponse>(`/storeapi/api/v2/store/comment`, {
    data,
    method: 'post',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
